import React, { Fragment } from 'react';
import CheckIcon from '@mui/icons-material/Check';

import './stepper.scss';
export const Stepper = ({
    steps = []
}) => {

    const getType = (status, type) => {
        return status?.toUpperCase() === type;
    }

    return (
        <div className='stepper-container'>
            {steps
                ?.sort((firstValue, secondValue) => firstValue.order - secondValue.order)
                ?.map((step, index) => {
                    const isActive = getType(step.status, 'ACTIVE');
                    const isCompleted = getType(step.status, 'COMPLETED');
                    const isDisabled = getType(step.status, 'DISABLED');
                    return (
                        <Fragment key={`index-${index}-${step.stepName}`}>
                            <div className={`step-label-container ${isActive && 'active-background'}`}>
                                {isCompleted && (
                                    <CheckIcon className='completed-step-icon' />
                                )}
                                {isActive && (
                                    <div className='active-step-icon' />
                                )}
                                {isDisabled && (
                                    <div className='disabled-step-icon' />
                                )}
                                <span className={`option-stepname ${isActive && 'active-label'}`}>{step.stepName}</span>
                            </div>
                            {steps[index + 1] &&
                                <div className='divider-container'>
                                    <div className={`step-divider ${isCompleted && 'completed'}`} />
                                </div>
                            }
                        </Fragment>
                    )
                })
            }
        </div>
    )
}